import classNames from "classnames";

const clsx = (...arg: Parameters<typeof classNames>) => {
  return classNames(...arg);
};

export default clsx;